import {
  App,
  Button,
  Card,
  Checkbox,
  Col,
  Input,
  message,
  Pagination,
  Row,
  Select,

  Spin,
  Table,

} from "antd";
import { Option } from "antd/es/mentions";
import {

  LeftOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  EDIT_GROUP,
  LIST_USER,
  VIEW_GROUP,
  LIST_DEPARTMENTS
} from "../../apis/apis";

import debounce from "lodash.debounce";
import CulsightPageLoader from "../../components/CulsightPageLoader";

function AssignUser() {
  const [group_name_error, set_group_name_error] = useState("");
  const { notification } = App.useApp();
  const navigate = useNavigate();
  const [loader, setLoader] = useState(true);
  const [pagination_loader, set_pagination_loader] = useState(false);
  const [table_data, set_table_data] = useState([]);
  const [current_page, set_current_page] = useState("");
  const [total_pages, set_total_pages] = useState("");
  const [total_users, set_total_users] = useState("");
  const [search_query_key, set_search_query_key] = useState("name");
  const [search_query_value, set_search_query_value] = useState("");
  const [group_name, set_group_name] = useState("");
  const [group_id, set_group_id] = useState("");
  const [selected_users, set_selected_users] = useState([]);
  const [departmentList, setDepartmentList] = useState([]);
  const [departmentValue, setDepartmentValue] = useState("");


  useEffect(() => {
    const id = atob(window.location.pathname.split("/").pop());
    set_group_id(id);
  }, []);

  useEffect(() => {
    const GET_DEPARTMENTS = async () => {
      try {
        const res = await LIST_DEPARTMENTS(); // list-departments/
        if (res?.data?.status) {
          setDepartmentList(res.data.data || []);
        }
      } catch (err) {
        console.error("Department API Error:", err);
      }
    };

    GET_DEPARTMENTS();
  }, []);


  useEffect(() => {
    const View_GROUP_API = async () => {
      try {
        const formData = new FormData();
        formData.append("id", group_id);
        const response = await VIEW_GROUP(formData);

        if (response?.data?.status) {
          set_group_name(response?.data?.data?.name);
          set_selected_users(response?.data?.data?.contacts || []);
        } else {
          message.error("Failed to fetch group details.");
        }
      } catch (error) {
        message.error("Server error while fetching group.");
      }
    };

    if (group_id) {
      View_GROUP_API();
    }
  }, [group_id]);

  const handleDepartmentChange = (val) => {
    setDepartmentValue(val);
    set_search_query_value(""); // text search reset

    // 🔹 CASE 1: department CLEAR hua
    if (!val) {
      LIST_API();          // 👈 FULL LIST wapas lao
      return;
    }

    // 🔹 CASE 2: department SELECT hua
    fetchResults("department", val);
  };



  const handleOk = async () => {
    const error = validateGroupName(group_name);
    if (error) {
      set_group_name_error(error);
      return;
    }
    try {
      const formData = new FormData();
      formData.append("id", group_id);
      formData.append("name", group_name);
      formData.append("contact_list", selected_users.join(","));

      const response = await EDIT_GROUP(formData);
      if (response?.data?.status) {
        notification.success({
          message: "Success",
          description: response?.data?.message,
        });

        navigate("/user-group");
      } else {
        message.error(response?.data?.message || "Failed to update group.");
      }
    } catch (error) {
      message.error("Server error while updating group.");
    }
  };

  const fetchResults = useCallback((search_key, search_value) => {
    debounce(async () => {
      try {
        set_pagination_loader(true);
        const FORM_DATA = new FormData();
        FORM_DATA.append(search_key, search_value);
        const API_CALL = await LIST_USER(FORM_DATA);
        if (API_CALL?.data?.status) {
          set_table_data(API_CALL?.data?.data);
          set_current_page(API_CALL?.data?.current_page);
          set_total_pages(API_CALL?.data?.total_pages);
          set_total_users(API_CALL?.data?.total_users);
        }
      } catch (err) {
        console.error("API Error:", err);
      } finally {
        set_pagination_loader(false);
      }
    }, 500)();
  }, []);

  const LIST_API = async () => {
    const FORM_DATA = new FormData();
    const API_CALL = await LIST_USER(FORM_DATA);
    if (API_CALL?.data?.status) {
      set_table_data(API_CALL?.data?.data);
      set_current_page(API_CALL?.data?.current_page);
      set_total_pages(API_CALL?.data?.total_pages);
      set_total_users(API_CALL?.data?.total_users);
      setLoader(false);
    } else {
      setLoader(false);
    }
  };

  useEffect(() => {
    LIST_API();
  }, []);


  const selectBefore = (
    <Select
      defaultValue="Name"
      onChange={(value) => {
        if (value === "Name") set_search_query_key("name");
        if (value === "Email") set_search_query_key("email");
        if (value === "Phone") set_search_query_key("contact_no");

        set_search_query_value(""); // input clear
      }}
    >
      <Option value="Name">Name</Option>
      <Option value="Email">Email</Option>
      <Option value="Phone">Phone</Option>
    </Select>
  );

  const columns = [
    {
      title: (
        <Checkbox
          checked={
            table_data?.length > 0 &&
            table_data.every((item) => selected_users.includes(item.id))
          }
          indeterminate={
            table_data?.some((item) => selected_users.includes(item.id)) &&
            !table_data.every((item) => selected_users.includes(item.id))
          }
          onChange={(e) => {
            const currentPageIds = table_data.map((item) => item.id);

            if (e.target.checked) {
              set_selected_users((prev) => [
                ...new Set([...prev, ...currentPageIds]),
              ]);
            } else {
              set_selected_users((prev) =>
                prev.filter((id) => !currentPageIds.includes(id))
              );
            }
          }}
        >
          Select All
        </Checkbox>
      ),
      key: "select",
      render: (_, record) => (
        <Checkbox
          checked={selected_users.includes(record.id)}
          onChange={(e) => {
            if (e.target.checked) {
              set_selected_users((prev) => [...prev, record.id]);
            } else {
              set_selected_users((prev) =>
                prev.filter((id) => id !== record.id)
              );
            }
          }}
        />
      ),
    },
    {
      title: "Name",
      dataIndex: "name",
      render: (_, record) => (
        <span>
          {record.name}
        </span>
      ),
    },
    {
      title: "Email",
      dataIndex: "email",
      render: (_, record) => <span>{record.email}</span>,
    },

    {
      title: "Department",
      dataIndex: "organization",
      render: (val) => {
        if (
          val === null ||
          val === undefined ||
          val === "" ||
          val === "null" ||
          val === "NaN" ||
          val === "nan"
        ) {
          return "Unassigned";
        }

        return val;
      },
    },
    {
      title: "Phone",
      dataIndex: "contact_no",
      render: (_, record) => <span>{record.contact_no || "No Data"}</span>,
    }
  ];

  const pagination_on_change = async (page) => {
    set_pagination_loader(true);
    const FORM_DATA = new FormData();
    FORM_DATA.append("page", page);
    FORM_DATA.append("token", localStorage.getItem("token"));
    FORM_DATA.append(search_query_key, search_query_value);
    if (departmentValue) {
      FORM_DATA.append("department", departmentValue);
    }

    const API_CALL = await LIST_USER(FORM_DATA);
    if (API_CALL?.data?.status) {
      set_table_data(API_CALL?.data?.data);
      set_current_page(API_CALL?.data?.current_page);
      set_total_pages(API_CALL?.data?.total_pages);
      set_total_users(API_CALL?.data?.total_users);
    }
    set_pagination_loader(false);
  };

  const handleInput = (e) => {
    const value = e.target.value;
    set_search_query_value(value);
    fetchResults(search_query_key, value);
  };

  const validateGroupName = (value) => {
    if (!value || value.trim() === "") {
      return "Group name is required";
    }
    if (value.length < 2) {
      return "Group name must be at least 2 characters";
    }
    if (value.length > 50) {
      return "Group name cannot exceed 50 characters";
    }
    if (!/^[A-Za-z ]+$/.test(value)) {
      return "Only alphabets and spaces are allowed";
    }
    return "";
  };


  return (
    <div className="lms-body">
      <Card>

        <Row>
          <Col span={24}>
            <h3 style={{ cursor: "pointer" }} onClick={() => navigate("/user-group")}>
              <LeftOutlined /> Go to back
            </h3>
          </Col>
          <Col span={23} style={{ marginTop: "15px" }}>
            <label htmlFor="">Name</label>
            <Input
              placeholder="Enter group name"
              value={group_name}
              showCount
              onChange={(e) => {
                const value = e.target.value;
                set_group_name(value);
                set_group_name_error(validateGroupName(value));
              }}
            />
            {group_name_error && (
              <span style={{ color: "red" }}>{group_name_error}</span>
            )}


          </Col>
        </Row>

        <Row style={{ marginTop: "15px" }} gutter={16}>
          {/* Search */}
          <Col span={12}>
            <Input
              addonBefore={selectBefore}
              placeholder={`Search by ${search_query_key === "name"
                ? "name"
                : search_query_key === "email"
                  ? "email"
                  : "phone"
                }`}
              onChange={handleInput}
              size="large"
            />

          </Col>

          {/* Department Filter */}
          <Col span={12}>
            <div style={{ display: "flex", alignItems: "center", gap: "8px", float: "right" }}>
              <span style={{ fontSize: "16px", fontWeight: 500 }}>Department:</span>
              <Select
                showSearch
                allowClear
                style={{
                  minWidth: "100px",
                  width: "auto",
                }}
                placeholder="Select Department"
                value={departmentValue || undefined}
                onChange={handleDepartmentChange}
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.children.toLowerCase().includes(input.toLowerCase())
                }
              >
                {departmentList.map((dep, index) => (
                  <Option key={index} value={dep}>
                    {dep}
                  </Option>
                ))}
              </Select>
            </div>
          </Col>
        </Row>


        {loader ? (
          <CulsightPageLoader />
        ) : pagination_loader ? (
          <div style={{ textAlign: "center", padding: "60px" }}>
            <Spin indicator={<LoadingOutlined spin />} size="large" />
          </div>
        ) : (
          <>
            <Table
              columns={columns}
              pagination={false}
              dataSource={table_data}
              style={{ marginTop: "15px" }}
              rowKey="id"
            />

            {total_pages > 0 ? (
              <div style={{ float: "right", marginTop: "20px" }}>
                <Pagination
                  onChange={pagination_on_change}
                  current={current_page}
                  total={total_users}
                  pageSize={9}
                />
              </div>
            ) : (
              <div style={{ textAlign: "center", color: "red" }}>
                <h2>No Learner Found</h2>
              </div>
            )}
          </>
        )}

        <Button type="primary" onClick={handleOk} style={{ marginTop: "20px" }}>
          Save
        </Button>
      </Card>
    </div>
  );
}

export default AssignUser;
